// IMPORTS
// Modules
import { Link } from 'react-router-dom';
// Assets
import icon_oneport_light from './../../../onehivesystems/logos/oneport_logo_icon_white.svg';
import icon_oneport_dark from './../../../onehivesystems/logos/oneport_logo_icon_black.svg';



// COMPONENT
export default function NavigateApps (props) {
   return (
      <div className="globaldashboard-navigateapps">
         <Link to='/oneacl'>
            {/* <img src={props.onehive.theme === props.onehive.themes.light ? icon_oneport_dark : icon_oneport_light} alt="OnePort Icon" /> */}
            <p>OneACL</p>
         </Link>
         <Link to='/oneport'>
            <img src={props.onehive.theme === props.onehive.themes.light ? icon_oneport_dark : icon_oneport_light} alt="OnePort Icon" />
            <p>OnePort</p>
         </Link>
      </div>
   );
}